export function LearnStats({ stats, areaCount, onOpenSaved }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 lg:gap-5" data-testid="learn-stats">
      <div className="bg-white rounded-3xl p-5 card-soft">
        <p className="text-xs uppercase tracking-widest text-[#291B2D]/50">Completed</p>
        <p className="font-heading text-2xl lg:text-3xl mt-1">{stats.completed}<span className="text-base text-[#291B2D]/40"> / {stats.total}</span></p>
      </div>
      <button onClick={onOpenSaved} className="text-left bg-[#F7F2EA] rounded-3xl p-5 hover:-translate-y-0.5 transition-smooth">
        <p className="text-xs uppercase tracking-widest text-[#291B2D]/50">Saved</p>
        <p className="font-heading text-2xl lg:text-3xl mt-1">{stats.saved}</p>
      </button>
      <div className="bg-white rounded-3xl p-5 card-soft">
        <p className="text-xs uppercase tracking-widest text-[#291B2D]/50">Areas</p>
        <p className="font-heading text-2xl lg:text-3xl mt-1">{areaCount}</p>
      </div>
      <div className="bg-[#291B2D] text-white rounded-3xl p-5 card-soft">
        <p className="text-xs uppercase tracking-widest text-[#C89B55]">Library progress</p>
        <p className="font-heading text-2xl lg:text-3xl mt-1">{stats.pct}%</p>
      </div>
    </div>
  );
}
